module.exports = __webpack_public_path__ + "img/logo-block-light.8a181604.svg";